import { SingleResponse, APIClientInterface, MaintenanceMessage, MaintenanceMessageServiceInterface } from '../types'

export default class MaintenanceMessageService implements MaintenanceMessageServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async get(): Promise<SingleResponse<MaintenanceMessage>> {
		return this.client.get(`/maintenance`)
	}
}
